// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Row$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";

function CardTitleWithImage(Props) {
  var title = Props.title;
  var icon_src = Props.icon_src;
  return React.createElement(Row$Catalyst.make, {
              children: null,
              className: "c-card-title"
            }, React.createElement("img", {
                  className: "icon",
                  src: icon_src
                }), title);
}

var make = CardTitleWithImage;

export {
  make ,
  
}
/* react Not a pure module */
